import { render, staticRenderFns } from "./ChatMessageList.vue?vue&type=template&id=390b4c3c&scoped=true"
import script from "./ChatMessageList.vue?vue&type=script&lang=js"
export * from "./ChatMessageList.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageList.vue?vue&type=style&index=0&id=390b4c3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b4c3c",
  null
  
)

export default component.exports